import script from "./FileTable.vue?vue&type=script&setup=true&lang=js"
export * from "./FileTable.vue?vue&type=script&setup=true&lang=js"

import "./FileTable.vue?vue&type=style&index=0&id=4526c1fb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4526c1fb"]])

export default __exports__